/**
 * 동일 API가 짧은 시간에 동시에 여러 번 호출될 때,
 * 진행 중인 요청의 Promise를 공유해 네트워크 중복을 방지합니다.
 *
 * - 동시(in-flight) 중복만 처리합니다. 순차 호출은 그대로 나갑니다.
 * - config.skipDedup = true 로 개별 요청에서 비활성화할 수 있습니다.
 */

const pendingRequests = new Map();

export function getRequestKey(config) {
	const { method = 'get', url, params, data } = config;

	let serializedData = '';
	try {
		serializedData =
			typeof data === 'string' ? data : JSON.stringify(data ?? {});
	} catch {
		serializedData = String(data);
	}

	let serializedParams = '';
	try {
		serializedParams = JSON.stringify(params ?? {});
	} catch {
		serializedParams = String(params);
	}

	return `${String(method).toUpperCase()}&${url}&${serializedParams}&${serializedData}`;
}

/**
 * @param {import('axios').AxiosAdapter} defaultAdapter
 * @returns {import('axios').AxiosAdapter}
 */
export function createDedupAdapter(defaultAdapter) {
	return async function dedupAdapter(config) {
		if (config.skipDedup) {
			return defaultAdapter(config);
		}

		const key = getRequestKey(config);

		if (pendingRequests.has(key)) {
			return pendingRequests.get(key);
		}

		const requestPromise = Promise.resolve(defaultAdapter(config)).finally(
			() => {
				pendingRequests.delete(key);
			},
		);

		pendingRequests.set(key, requestPromise);
		return requestPromise;
	};
}
